import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { MapContainer, TileLayer, useMap, Marker, Popup } from 'react-leaflet'
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

export default function ViewFarm() {
  const params = useParams();
    const { user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [farm, setFarm] = useState();

    const DefaultIcon = L.icon({
        iconUrl: icon,
        shadowUrl: iconShadow,
        iconSize: [30, 50],
        iconAnchor: [15, 50]
    });
    L.Marker.prototype.options.icon = DefaultIcon;

    console.log("view farm page")

    // Load user
    useEffect(() => {
        console.log("loading farm...",params.id);

       
            axios
              .get(`https://${process.env.REACT_APP_IP}/api/farms/${params.id}`, {
                headers: { Authorization: `bearer ${user.token}` },
              })
              .then((res) => {
                console.log("Farm:", res.data);
                setFarm(res.data);
                setLoading(false);
              })
              .catch((err) => {
                console.log(err);
                setLoading(false);
              });
          
    }, [])

    
    
    return (
        <div className="page">
            {loading && (<Spinner />)}
            {!loading && farm && (
                <div className="row">
                    <div className="col-md-8">


                        { /* Farm Name Header */}
                        <div className="row">
                            <div className="col-12">
                                <h1>
                                    {farm.name} ({farm.businessName})
                                    <Link to={`/Farms/Edit/${farm.id}`} className="btn-sm btn-other" style={{ marginLeft: 10 }}>Edit</Link>
                                </h1>
                            </div>
                        </div>
                        


                        <div className="row">
                            <div className="col-6">
                                { /* Address Header */}
                                <h3>Address</h3>

                                {/* Address */}
                                <div className="col-12" style={{ whiteSpace: "pre-line" }}>
                                    {farm.address || farm.postcode ? (
                                        <>
                                            {farm.address && <>{farm.address}<br /></>}
                                            {farm.postcode}
                                        </>
                                    ) : (
                                        <em>No address set</em>
                                    )}
                                </div>
                            </div>
                            <div className="col-6">
                                { /* Primary Contact Header */}
                                <div className="col-12">
                                    <h3 style={{ marginTop: 20 }}>Primary Contact</h3>
                                </div>


                                {/* Address */}
                                <div className="col-12" style={{ whiteSpace: "pre-line" }}>
                                    {farm.primaryContact || farm.email || farm.telephone ? (
                                        <>
                                            {farm.primaryContact && <>{farm.primaryContact}<br /></>}
                                            {farm.telephone && <>{farm.telephone}<br /></>}
                                            {farm.email && <>{farm.email}</>}
                                        </>
                                    ) : (
                                        <em>No primary contact set</em>
                                    )}
                                </div>
                            </div>
                        </div>

                        <hr />

                        { /* Details Header */}
                        <div className="row">
                            <div className="col-md-12">
                                <h3>Details</h3>
                            </div>
                        </div>

                        { /* Referred By */}
                        <div className="row">
                            <div className="col-6">
                                Referred By
                            </div>
                            <div className="col-6">
                                {farm.referredBy}
                            </div>
                        </div>

                        { /* SBI */}
                        <div className="row">
                            <div className="col-6">
                                SBI
                            </div>
                            <div className="col-6">
                                {farm.sbi}
                            </div>
                        </div>

                        { /* Companies Supplied */}
                        <div className="row">
                            <div className="col-6">
                                Companies Supplied
                            </div>
                            <div className="col-6">
                                {farm.companiesSupplied && farm.companiesSupplied.map((item, index) => (
                                    <span key={index}>
                                        {item}{index < farm.companiesSupplied.length - 1 ? ', ' : ''}
                                    </span>
                                ))}
                            </div>
                        </div>

                        { /* NVZ */}
                        <div className="row">
                            <div className="col-6">
                                Is Farm Within An NVZ?
                            </div>
                            <div className="col-6">
                                {farm.nvz ? 'Yes' : 'No'}
                            </div>
                        </div>
                            
                            
                        

                        <hr />

                        

                    </div>

                    {/* Location map */ }
                    <div className="col-md-4 text-end  d-none d-lg-block">
                        <div >
                            <MapContainer center={[farm.latitude ?? -3, farm.longitude ?? 55]} zoom={6} scrollWheelZoom={false} style={{ height: 400, width: '100wh' }}>
                            <TileLayer
                                    attribution="Imagery &copy; <a href='https://www.mapbox.com/'>Mapbox</a>"
                                    url="https://api.tiles.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoiaXRhZGNvbGxlY3QiLCJhIjoiY2szNXNhemdoMGx1aTNocGU3bGRwMjJpbSJ9.V7BIAIP0gFWXMzi9Uq-9QQ"
                            />
                                {farm.longitude && (
                                    <Marker position={[farm.latitude ?? -3, farm.longitude ?? 53]}>
                                    <Popup>
                                            <strong>{farm.name}</strong><br />
                                            {farm.address} <br />
                                            {farm.postcode}.
                                    </Popup>
                                    </Marker>
                                )}
                            </MapContainer>
                        </div>
                    </div>
                </div>

            )}
        </div>
  )
}
